export const updateNotes = {
  title: 'Atualização concluída',
}

export const reportExportWarning = {
  title: 'Aviso!',
  text: 'Novas informações referente ao manejo estarão disponíveis no relatório de exportação em algumas horas',
}

export const changeCowsToBatchNotes = {
  title: 'Deseja mover esta matriz para este lote?',
  text: 'Ao realizar esta ação a matriz será transferida para este lote.',
}

export const duplicatePage = {
  title: 'Página duplicada!',
  text: 'Para evitar uma possível perda de dados, não é permitido abrir o Progerar em mais de uma aba! Para continuar utilizando, feche esta página e volte para utilizar a anterior.',
}
